export default {
    en: {
        retourAuSommaire: 'Back to AccèsD home'
    },
    fr: {
        retourAuSommaire: 'Retour à l’accueil'
    }
};
